module.exports = __webpack_public_path__ + "img/ico_btn_comment_like_on.91a67fd.svg";